// src/Assets/Components/Banner.js

import './Banner.css';

const headlines = [
  {
    text: 'Check out the piece I wrote on Ocean Circulation published at Resilience.org',
    url: 'https://www.resilience.org/stories/2025-07-25/the-southern-ocean-shift-a-warning-sign-in-global-climate-circulation/',
  },
  {
    text: 'Check out the piece I wrote on Ocean Circulation published at Resilience.org',
    url: 'https://www.resilience.org/stories/2025-07-25/the-southern-ocean-shift-a-warning-sign-in-global-climate-circulation/',
  },
];

const Banner = () => {
  return (
    <div className='banner'>
      <div className='banner-scroll'>
        {[...headlines, ...headlines].map((item, index) => (
          <a
            key={index}
            className='banner-link'
            href={item.url}
            target='_blank'
            rel='noopener noreferrer'
          >
            {item.text}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Banner;
